"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPlaceholder = exports.getPulsar = exports.getOverlay = exports.getContentWrapper = void 0;

var getContentWrapper = function getContentWrapper(theme, out) {
  var from = "\n                opacity: 0;\n                visibility: hidden;\n            ",
      to = "\n                opacity: 1;\n                visibility: visible;\n            ";
  return "\n            from {\n                ".concat(out ? to : from, "\n            }\n            \n            to {\n                ").concat(out ? from : to, "\n            }\n    ");
},
    getOverlay = function getOverlay(theme, out) {
  var from = "\n                transform: ".concat(theme.overlayPositionTransform, " scale(0);\n                opacity: 0.5;\n            "),
      to = "\n                transform: ".concat(theme.overlayPositionTransform, " scale(1);\n                opacity: ").concat(theme.overlayOpacity, ";\n            ");
  return "\n            from {\n                ".concat(out ? to : from, "\n            }\n            \n            to {\n                ").concat(out ? from : to, "\n            }\n    ");
},
    getPulsar = function getPulsar() {
  return "\n        0% {\n            transform: translate(-50%,-50%) scale(0.5);\n            opacity: 0;\n        }\n        \n        25% {\n            transform: translate(-50%,-50%) scale(2);\n            opacity: 0.54;\n        }\n        \n        50%, 100% {\n            transform: translate(-50%,-50%) scale(3);\n            opacity: 0;\n        }\n    ";
},
    getPlaceholder = function getPlaceholder() {
  return "\n        0% {\n            transform: translate(-50%,-50%) scale(1);\n        }\n        \n        25% {\n            transform: translate(-50%,-50%) scale(1.6);    \n        }\n        \n        50% {\n            transform: translate(-50%,-50%) scale(1.3);    \n        }\n        \n        100% {\n            transform: translate(-50%,-50%) scale(1);    \n        }\n    ";
};

exports.getPlaceholder = getPlaceholder;
exports.getPulsar = getPulsar;
exports.getOverlay = getOverlay;
exports.getContentWrapper = getContentWrapper;